
import {  axiosGet, axiosPost } from '../AxiosRequests';
//*** Lib */
import { GetAllModuleNameList, UpdateFileDeleteEligibiltyAfterDaysByModuleType,  } from '../ApiEndPoints';

export default class FileConfigServices {


    async getAllModuleNameList(request) {
        return axiosGet(GetAllModuleNameList, request);
    }
    async updateFileDeleteEligibiltyAfterDaysByModuleType(request) {
        return axiosPost(UpdateFileDeleteEligibiltyAfterDaysByModuleType, request);
    }

}